import { render, staticRenderFns } from "./LmTrialNotice.vue?vue&type=template&id=096df54e"
import script from "./LmTrialNotice.vue?vue&type=script&lang=js"
export * from "./LmTrialNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports